var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelevisions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.917,143.946l66.236-66.236c3.624,1.906,7.745,2.99,12.116,2.99c14.404,0,26.122-11.719,26.122-26.122 c0-14.403-11.719-26.122-26.122-26.122c-14.404,0-26.122,11.719-26.122,26.122c0,4.336,1.068,8.425,2.946,12.029L256,140.697 L213.832,98.53c2.126-3.778,3.345-8.131,3.345-12.767c0-14.404-11.719-26.122-26.122-26.122 c-14.403,0-26.122,11.719-26.122,26.122c0,14.404,11.719,26.122,26.122,26.122c4.071,0,7.926-0.937,11.364-2.605l34.664,34.665H0 v339.598h302.805V467.87H15.673V159.619h480.653V467.87H389.532v15.673H512V143.946H274.917z M353.268,44.129 c5.762,0,10.449,4.687,10.449,10.449c0,5.762-4.687,10.449-10.449,10.449c-5.762,0-10.449-4.687-10.449-10.449 C342.82,48.816,347.507,44.129,353.268,44.129z M191.054,96.213c-5.762,0-10.449-4.687-10.449-10.449s4.687-10.449,10.449-10.449 s10.449,4.687,10.449,10.449C201.503,91.525,196.816,96.213,191.054,96.213z",
    fill: "#c72538"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M378.73,175.293H60.082c-15.845,0-28.735,12.891-28.735,28.735v219.435c0,15.845,12.89,28.735,28.735,28.735H378.73 c15.845,0,28.735-12.89,28.735-28.735V204.027C407.464,188.183,394.574,175.293,378.73,175.293z M391.791,423.462 c0,7.203-5.859,13.061-13.061,13.061H60.082c-7.203,0-13.061-5.859-13.061-13.061V204.027c0-7.203,5.859-13.061,13.061-13.061 H378.73c7.202,0,13.061,5.859,13.061,13.061V423.462z",
    fill: "#c72538"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.429,206.641L91.429,206.641c-15.845-0.001-28.735,12.889-28.735,28.734v62.642h15.673v-62.642 c0-7.202,5.859-13.061,13.061-13.061h54.183v-15.673H91.429z",
    fill: "#c72538"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M451.895,373.823c-18.725,0-33.959,15.235-33.959,33.959c0,18.725,15.235,33.959,33.959,33.959 s33.959-15.235,33.959-33.959C485.855,389.058,470.62,373.823,451.895,373.823z M451.895,426.068 c-10.082,0-18.286-8.203-18.286-18.286s8.203-18.286,18.286-18.286s18.286,8.203,18.286,18.286S461.978,426.068,451.895,426.068z",
    fill: "#c72538"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 422.12,
    y: 185.751,
    width: 59.56,
    height: 15.673,
    fill: "#c72538"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 422.12,
    y: 217.121,
    width: 59.56,
    height: 15.673,
    fill: "#c72538"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 422.12,
    y: 248.491,
    width: 59.56,
    height: 15.673,
    fill: "#c72538"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 164.41,
    y: 206.641,
    width: 15.673,
    height: 15.673,
    fill: "#c72538"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321.09,
    y: 467.871,
    width: 15.673,
    height: 15.673,
    fill: "#c72538"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 355.57,
    y: 467.871,
    width: 15.673,
    height: 15.673,
    fill: "#c72538"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevisions);
export default __webpack_public_path__ + "static/media/televisions.236a3bdc8553a79e280df53e2c75b0e2.svg";
export { ForwardRef as ReactComponent };